"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1740))
 * @lastsynced 2026-10-29T13:53:55.426Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const StarFilled = createSVGIcon(
  <path
    d="m12.847 1.87 2.714 5.5a.94.94 0 0 0 .708.515l6.072.884a.94.94 0 0 1 .514 1.603l-4.396 4.286a.94.94 0 0 0-.269.831l1.037 6.055a.94.94 0 0 1-1.371.99l-5.415-2.848a.94.94 0 0 0-.875 0l-5.429 2.856a.94.94 0 0 1-1.371-.99l1.037-6.054a.94.94 0 0 0-.27-.832l-4.388-4.289a.939.939 0 0 1 .514-1.603l6.08-.89a.94.94 0 0 0 .707-.514l2.714-5.5a.94.94 0 0 1 1.687 0"
    fill="currentColor"
  />,
  "StarFilled",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
